export default value => (value.length > 1 ? value.replace(/./g, '•') : value);



// WEBPACK FOOTER //
// ./src/components/ProfileLayout/utils/transformSsnValue.js